import {initModel as apiInitModel} from '../modules/apiWrapper.js';
import {getInState} from '../helpers/composeReducer.js';
import {BOOKMARK_STATUS_DOWNLOADED} from '../actions/bookmark.action.js';

export const MODEL_LOAD = 'model load';
export const MODEL_START = 'model start';
export const MODEL_ERROR = 'model error';
export const ENABLE_TITLE_CHANGE = 'enable title change';

export function initModel(isbn13){
    return function(dispatch, getState){
        dispatch({
            type : MODEL_START,
            isbn13
        });

        let partner = getInState(getState,'options.partner_name','');
        let app_id = getInState(getState,'app.id');
        let logger = getInState(getState, 'helpers.logger')

        apiInitModel(isbn13, partner, '', app_id, logger).then(function(payload){
            dispatch({
                type : MODEL_LOAD,
                ...payload
            });

            dispatch({
                type : BOOKMARK_STATUS_DOWNLOADED
            });

        }, function(e){
            dispatch({
                type : MODEL_ERROR,
                error : e
            });
        });
    };

}

export function enableTitleChange(){
    return function(dispatch){
        dispatch({
            type: ENABLE_TITLE_CHANGE
        })
    }
}



// WEBPACK FOOTER //
// ./src/actions/model.action.js